"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordProtect = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var OptionCheckbox_1 = require("../OptionCheckbox/OptionCheckbox");
var PasswordProtect = (function (_super) {
    __extends(PasswordProtect, _super);
    function PasswordProtect() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.passwordInputRef = (0, react_1.createRef)();
        _this.hasBeenFocused = false;
        _this.pageLinkPasswordToggled = function () {
            _this.props.link.isPasswordProtected = !_this.props.link.isPasswordProtected;
            if (_this.isPasswordProtected) {
                _this.props.telemetry.trackOnly("Project Security Password Applied");
                setTimeout(function () {
                    var _a;
                    (_a = _this.passwordInputRef.current) === null || _a === void 0 ? void 0 : _a.focus({ preventScroll: true });
                });
            }
            else {
                _this.props.link.password = "";
                _this.props.link.hasPassword = false;
            }
            _this.props.updateLink();
        };
        _this.changePageLinkPassword = function (newPassword) {
            _this.props.link.password = newPassword;
        };
        _this.updatePageLinkPassword = function () {
            _this.props.link.hasPassword = true;
            _this.props.updateLinkPassword();
        };
        return _this;
    }
    PasswordProtect.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, Promise, function () {
            var msg;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.linkOriginal = (0, cloneDeep_1.default)(this.props.link);
                        return [4, this.props.getUpsellMessage(FeatureFlag_1.default.Security)];
                    case 1:
                        msg = _a.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.securityUpsell = msg;
                        });
                        return [2];
                }
            });
        });
    };
    PasswordProtect.prototype.componentWillUnmount = function () {
        var prevIsPasswordProtected = this.linkOriginal.isPasswordProtected;
        if (prevIsPasswordProtected == this.isPasswordProtected)
            return;
        this.props.sendSettingChangedTelemetry(this.isPasswordProtected ? "password_enabled" : "password_disabled");
    };
    Object.defineProperty(PasswordProtect.prototype, "isPasswordProtected", {
        get: function () {
            return this.props.link.isPasswordProtected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PasswordProtect.prototype, "linkPassword", {
        get: function () {
            return this.props.link.password;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PasswordProtect.prototype, "hasPassword", {
        get: function () {
            return this.props.link.hasPassword;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PasswordProtect.prototype, "showWarning", {
        get: function () {
            var _a = this.props, isLive = _a.isLive, link = _a.link;
            return this.hasBeenFocused && isLive && link.hasPassword;
        },
        enumerable: false,
        configurable: true
    });
    PasswordProtect.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(OptionCheckbox_1.OptionCheckbox, { item: {
                    id: "password-checkbox",
                    value: "password-checkbox",
                    label: "Password",
                }, isSelected: this.isPasswordProtected, onChange: this.pageLinkPasswordToggled, isDisabled: this.props.disableSetting }),
            this.isPasswordProtected && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.TextInput, { label: "password-protect-input", id: "password-protect-input", labelHidden: true, value: this.linkPassword, disabled: !this.isPasswordProtected, placeholder: this.hasPassword ? "•••••••" : undefined, type: kaleidoscope_1.TextInputType.Password, onChange: function (newPassword) { return _this.changePageLinkPassword(newPassword); }, onBlur: this.updatePageLinkPassword, onFocus: (0, mobx_1.action)(function () { return (_this.hasBeenFocused = true); }), ref: this.passwordInputRef }),
                react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: this.showWarning, id: "password-protect-warning" }, function (_a) {
                    var expandableElementRef = _a.expandableElementRef;
                    return (react_1.default.createElement("div", { ref: expandableElementRef, className: "password-protect-warning" },
                        react_1.default.createElement(kaleidoscope_1.Text, { size: "xs" }, "If you change the password, anyone using the current password will no longer have access")));
                })))));
    };
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], PasswordProtect.prototype, "hasBeenFocused", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], PasswordProtect.prototype, "securityUpsell", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PasswordProtect.prototype, "isPasswordProtected", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", String),
        __metadata("design:paramtypes", [])
    ], PasswordProtect.prototype, "linkPassword", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PasswordProtect.prototype, "hasPassword", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PasswordProtect.prototype, "showWarning", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PasswordProtect.prototype, "pageLinkPasswordToggled", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PasswordProtect.prototype, "changePageLinkPassword", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], PasswordProtect.prototype, "updatePageLinkPassword", void 0);
    PasswordProtect = __decorate([
        mobx_react_1.observer
    ], PasswordProtect);
    return PasswordProtect;
}(react_1.default.Component));
exports.PasswordProtect = PasswordProtect;
exports.default = PasswordProtect;
